export const ITEM_CATEGORY_LIST = "ITEM_CATEGORY_LIST";
export const DROPDOWN = "DROPDOWN";
export const ITEM_CATEGORY_STORE = "ITEM_CATEGORY_STORE";